if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      constructor() {
        super();
        this.addButton = this.querySelector('[data-upsell-add]');
        this.variantInput = this.querySelector('[data-upsell-variant]');
        this.message = this.querySelector('[data-upsell-message]');
        this.price = this.querySelector('[data-upsell-price]');

        this.addButton?.addEventListener('click', this.addToCart.bind(this));
        this.variantInput?.addEventListener('change', this.updatePrice.bind(this));
      }

      updatePrice() {
        const option = this.variantInput?.selectedOptions?.[0];
        if (option?.dataset.price && this.price) this.price.textContent = option.dataset.price;
      }

      async addToCart() {
        const variantId = Number(this.variantInput?.value);
        if (!variantId || this.addButton.disabled) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const spinner = this.addButton.querySelector('.loading__spinner');
        this.setMessage();
        this.addButton.disabled = true;
        this.addButton.classList.add('loading');
        spinner?.classList.remove('hidden');

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: cartDrawer?.getSectionsToRender().map((section) => section.id) || [],
            sections_url: window.location.pathname,
          });

          const response = await fetch(`${routes.cart_add_url}`, config);
          const responseData = await response.json();

          if (!response.ok || responseData.status) {
            throw new Error(responseData.description || responseData.message || 'This item could not be added.');
          }

          if (cartDrawer) {
            cartDrawer.renderContents(responseData);
          } else {
            window.location.href = routes.cart_url;
          }
        } catch (error) {
          this.setMessage(error.message || 'This item could not be added. Please try again.');
          this.addButton.disabled = false;
          this.addButton.classList.remove('loading');
          spinner?.classList.add('hidden');
        }
      }

      setMessage(message = '') {
        if (!this.message) return;
        this.message.textContent = message;
        this.message.hidden = !message;
      }
    }
  );
}